import {useQuery} from "react-query";
import {Client} from "../../autogenerate/api.generated.clients";

export interface HistoricalSensorReliabilityParams {
    startDate?: Date;
    endDate?: Date;
    orgId?: number;
}

export function useHistoricalSensorReliability({startDate, endDate, orgId}: HistoricalSensorReliabilityParams) {
    const startDateString = startDate?.toLocaleString();
    const endDateString = endDate?.toLocaleString();
    return useQuery(
        ['historical-sensor-reliability', startDate, endDate], 
        () => new Client().sensorReliability_GetHistoricalFleetSensorReliabilityReport(startDateString, endDateString, orgId),
        {
            enabled: !!startDate && !!endDate,
            refetchOnWindowFocus: false
        }
    );
}